import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { uerWorkOrderObjectTotalsGql } from 'pages/Project/UerProject/WorkOrder/workOrderQueries';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

const requestId = 'uerWorkOrderObjectTotals';

export const useUerWorkOrderObjectTotals = (workOrderId: number) => {
    const dispatch = useDispatch();

    const [uerWorkOrderObjectTotalsReset] = useResetStoreData({ requestId });

    const [uerWorkOrderObjectTotalsData, uerWorkOrderObjectTotalsStatus, , uerWorkOrderObjectTotalsRequest] =
        useRequest({
            requestId,
            query: uerWorkOrderObjectTotalsGql,
            withEffect: false,
        });

    const uerWorkOrderObjectTotalsMakeRequest = useCallback(
        (workOrderObjectId: number) => {
            uerWorkOrderObjectTotalsReset(undefined);
            dispatch(uerWorkOrderObjectTotalsRequest({ workOrderObjectId, workOrderId }));
        },
        [dispatch, uerWorkOrderObjectTotalsRequest, uerWorkOrderObjectTotalsReset, workOrderId],
    );

    return {
        uerWorkOrderObjectTotalsData,
        uerWorkOrderObjectTotalsStatus,
        uerWorkOrderObjectTotalsMakeRequest,
    };
};
